<template>
  <div>
    <div id="some-element1">第一个</div>
    <div id="some-element2">第二2个</div>
  </div>
</template>

<script>
  export default {
    name: 'Vue-tour',
    data () {
      return {
        steps: [
                {
                    element: '#some-element1',
                    popover: {
                    title: '第一项',
                    description: '第一项的描述',
                    position: 'bottom',
                    }
                },
                {
                    element: '#some-element2',
                    popover: {
                    title: '第二项',
                    description: '第二项的描述',
                    position: 'top',
                    }
                },
            ]
      }
    },
    mounted: function () {
      this.$driver.defineSteps(this.steps)
      setTimeout(() =>{
 this.$driver.start()
      },100)
       
    }
  }
</script>
<style>
</style>